import React, { PureComponent } from 'react';
import SessionActionCreator from '../../actions/SessionActionCreator';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import envConfig from '../../../static/config';
import cn from 'classnames';
import PropTypes from 'prop-types';

export default class MobileOverlay extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
    selectedTab: PropTypes.string,
    managePaymentClick: PropTypes.func,
    managePayeeClick: PropTypes.func,
    createSweep: PropTypes.func,
    createAlert: PropTypes.func,
    openFaq: PropTypes.func,
    getHeaderClass: PropTypes.func,
    handleCreateBudget: PropTypes.func,
    handleEditBudget: PropTypes.func,
    _smShow: PropTypes.func,
  };
  state = {
    faqFlag: false,
    left: 0,
    isOpen: false,
  };
  smShow = () => {
    this.closeNav();
    SpendingsActionCreator.getAllSelectedAccountNumnber();
  };
  closeNav = () => {
    this.setState({ isOpen: false });
    this.props.getHeaderClass('');
  };
  createAlertClick = () => {
    this.closeNav();
    this.props.createAlert();
  };
  createSweepClick = () => {
    this.closeNav();
    this.props.createSweep();
  };
  deleteSavingsPot = () => {
    this.closeNav();
    this.props._smShow();
  };
  logout = () => {
    SessionActionCreator.requestAccessTokenReset(true);
  };
  mobileOption = () => {
    return (
      <div className="overlay overlay-hugeinc">
        <nav>
          <button className="arrow" onClick={this.closeNav} />
          {this.moduleOptions()}
        </nav>
      </div>
    );
  };
  moduleOptions = () => {
    switch (this.props.selectedTab) {
      case 'payments':
        return (
          <ul>
            <li>
              {' '}
              <a className="" onClick={this.props.managePaymentClick}>
                <span className="title">
                  {this.props.content.managePayments}
                </span>
                <span className="icon icon-your-payments" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.props.managePayeeClick}>
                <span className="title">
                  {this.props.content.managePayeeLink}
                </span>
                <span className="icon icon-payees" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.logout}>
                <span className="title">Logout</span>
                <span className="icon icon-logout" />
              </a>
            </li>
          </ul>
        );

      case 'alerts':
        return (
          <ul>
            <li>
              <a className="" onClick={this.createAlertClick}>
                <span className="title">Create my Alerts</span>
                <span className="icon icon-alerts" />
              </a>
            </li>
            {envConfig.isSweepsEnabled ? (
              <li>
                <a className="" onClick={this.createSweepClick}>
                  <span className="title">Create my Sweeps</span>
                  <span className="icon icon-pound" />
                </a>
              </li>
            ) : (
              ''
            )}
            <li>
              <a className="" onClick={this.logout}>
                <span className="title">Logout</span>
                <span className="icon icon-logout" />
              </a>
            </li>
          </ul>
        );
      case 'savingpotslist':
        return (
          <ul>
            <li>
              <a className="" onClick={this.props._getCreateSavingPot}>
                <span className="title">
                  {this.props.content.SavingLinkAddPotMobile}
                </span>
                <span className="icon icon-goals" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.logout}>
                <span className="title">Logout</span>
                <span className="icon icon-logout" />
              </a>
            </li>
          </ul>
        );
      case 'savingpotedit':
        return (
          <ul>
            <li>
              <a className="" onClick={this.props._handleMoveMoney}>
                <span className="title">
                  {this.props.content.savingPotMoveMoneyButtonMobile}
                </span>
                <span className="icon icon-payments" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.props._editPot}>
                <span className="title">
                  {this.props.content.savingPotEditPotButtonMobile}
                </span>
                <span className="icon icon-edit" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.deleteSavingsPot}>
                <span className="title">
                  {this.props.content.savingPotDeletePotButtonMobile}
                </span>
                <span className="icon icon-delete" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.logout}>
                <span className="title">Logout</span>
                <span className="icon icon-logout" />
              </a>
            </li>
          </ul>
        );

      case 'savingpotreduce':
        return (
          <ul>
            <li>
              <a className="" onClick={this.props._smShow}>
                <span className="title">
                  {this.props.content.savingPotDeletePotButtonMobile}
                </span>
                <span className="icon icon-delete" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.logout}>
                <span className="title">Logout</span>
                <span className="icon icon-logout" />
              </a>
            </li>
          </ul>
        );

      case 'spendings':
        return (
          <ul>
            <li>
              <a className="" onClick={this.props.handleEditBudget}>
                <span className="title">Edit Budget</span>
                <span className="icon icon-edit" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.smShow}>
                <span className="title">Accounts</span>
                <span className="icon">
                  <img
                    width="25"
                    height="25"
                    src="../images/b/icons/Accounts.svg"
                    alt=""
                  />
                </span>
              </a>
            </li>
            <li>
              <a className="" onClick={this.logout}>
                <span className="title">Logout</span>
                <span className="icon icon-logout" />
              </a>
            </li>
          </ul>
        );
      case 'spendings1':
        return (
          <ul>
            <li>
              <a className="" onClick={this.props.handleCreateBudget}>
                <span className="title">Create Budget</span>
                <span className="icon icon-edit" />
              </a>
            </li>
            <li>
              <a className="" onClick={this.smShow}>
                <span className="title">Accounts</span>
                <span className="icon">
                  <img
                    width="25"
                    height="25"
                    src="../images/b/icons/Accounts.svg"
                    alt=""
                  />
                </span>
              </a>
            </li>
            <li>
              <a className="" onClick={this.logout}>
                <span className="title">Logout</span>
                <span className="icon icon-logout" />
              </a>
            </li>
          </ul>
        );
      default:
        return (
          <ul>
            <li>
              <a className="" onClick={this.logout}>
                <span className="title">Logout</span>
                <span className="icon icon-logout" />
              </a>
            </li>
          </ul>
        );
    }
  };
  optionClick = () => {
    this.setState({ isOpen: true });
    this.props.getHeaderClass('isPopOverOpen');
  };

  render() {
    const { isOpen } = this.state;
    return (
      <div className="meta-navigation">
        <a
          className={cn('user-options', { 'hide-options': isOpen })}
          title="User Options"
          ref="useroption"
          onClick={this.optionClick}
        >
          <span className="icon icon-item-dots icon-dot" />
        </a>
        {isOpen && <button className="backdrop" onClick={this.closeNav} />}
        {isOpen && this.mobileOption()}
      </div>
    );
  }
}
